import gql from 'graphql-tag';

export const getProfileVisibility = gql`
  query GetProfileVisibility($languageCode: LanguageCodeIso) {
    viewer {
      id
      profileVisibility(languageCode: $languageCode) {
        level
        description
      }
    }
  }
`;

export const updateProfileVisibilityMutation = gql`
  mutation UpdateProfileVisibility(
    $input: UpdateProfileVisibilityInput!
    $languageCode: LanguageCodeIso
  ) {
    updateProfileVisibility(input: $input) {
      viewer {
        id
        profileVisibility(languageCode: $languageCode) {
          level
          description
        }
      }
    }
  }
`;

export const getApproachability = gql`
  query GetApproachability {
    viewer {
      id
      approachability {
        approachable
      }
    }
  }
`;

export const updateApproachabilityMutation = gql`
  mutation UpdateApproachability($input: UpdateApproachabilityInput!) {
    updateApproachability(input: $input) {
      viewer {
        id
        approachability {
          approachable
        }
      }
    }
  }
`;

/*
  Shared profile:
*/

const shareableProfileSettings = gql`
  fragment shareableProfileSettings on ShareableProfileSettings {
    # profileSlug
    active
    # views
    url
    displayUrl
  }
`;

export const getShareableProfileSettings = gql`
  query GetShareableProfileSettings(
    $zone: Zone!
    $languageCode: LanguageCodeIso!
  ) {
    viewer {
      id
      shareableProfileSettings(languageCode: $languageCode, zone: $zone) {
        ...shareableProfileSettings
      }
    }
  }
  ${shareableProfileSettings}
`;

export const createShareableProfileSettings = gql`
  mutation CreateShareableProfileSettings(
    $zone: Zone!
    $languageCode: LanguageCodeIso!
  ) {
    createShareableProfileSettings {
      ... on CreateShareableProfileSettingsSuccess {
        viewer {
          id
          shareableProfileSettings(languageCode: $languageCode, zone: $zone) {
            ...shareableProfileSettings
          }
        }
      }
      ... on CreateShareableProfileSettingsFailure {
        error {
          message
        }
      }
    }
  }
  ${shareableProfileSettings}
`;

export const updateShareableProfileSettings = gql`
  mutation UpdateShareableProfileSettings(
    $active: Boolean!
    $zone: Zone!
    $languageCode: LanguageCodeIso!
  ) {
    updateShareableProfileSettings(input: { active: $active }) {
      ... on UpdateShareableProfileSettingsSuccess {
        viewer {
          id
          shareableProfileSettings(languageCode: $languageCode, zone: $zone) {
            ...shareableProfileSettings
          }
        }
      }
      ... on UpdateShareableProfileSettingsFailure {
        error {
          message
        }
      }
    }
  }
  ${shareableProfileSettings}
`;
